import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-card mt-8 shadow-card">
      <div className="container mx-auto px-4 py-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <div className="icon-container bot">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-bot h-6 w-6">
                <path d="M12 8V4H8"></path>
                <rect width="16" height="12" x="4" y="8" rx="2"></rect>
                <path d="M2 14h2"></path>
                <path d="M20 14h2"></path>
                <path d="M15 13v2"></path>
                <path d="M9 13v2"></path>
              </svg>
            </div>
            <span className="text-muted">© 2024-2025 AI Product Reviews. Powered by 👤 + 🤖 intelligence | Made with ✨ and ❤️ | iReview.ai</span>
          </div>
          <nav className="flex gap-6">
            <a href="/about" className="text-muted hover:text-text transition-colors">
              About
            </a>
            <a href="/privacy" className="text-muted hover:text-text transition-colors">
              Privacy
            </a>
            <a href="/terms" className="text-muted hover:text-text transition-colors">
              Terms
            </a>
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
